module.exports = __webpack_public_path__ + "img/dev_tool_request_get_404.ffcff319.png";